import api from './api';

// System Settings API (singleton)
export const settingsAPI = {
  get: () => api.get('/admin/settings/'),
  update: (data) => api.post('/admin/settings/', data),
};

// Allowed IPs API
export const allowedIPsAPI = {
  list: () => api.get('/admin/allowed-ips/'),
  create: (data) => api.post('/admin/allowed-ips/', data),
  update: (id, data) => api.patch(`/admin/allowed-ips/${id}/`, data),
  delete: (id) => api.delete(`/admin/allowed-ips/${id}/`),
  toggle: (id) => api.post(`/admin/allowed-ips/${id}/toggle/`),
};

// User Management API
export const usersAPI = {
  list: () => api.get('/admin/users/'),
  get: (id) => api.get(`/admin/users/${id}/`),
  create: (data) => api.post('/admin/users/', data),
  update: (id, data) => api.patch(`/admin/users/${id}/`, data),
  delete: (id) => api.delete(`/admin/users/${id}/`),
  toggleActive: (id) => api.post(`/admin/users/${id}/toggle_active/`),
  resetPassword: (id, password) => api.post(`/admin/users/${id}/reset_password/`, { password }),
  reset2fa: (id) => api.post(`/admin/users/${id}/reset_2fa/`),
};

// Dashboard Stats API
export const statsAPI = {
  overview: () => api.get('/admin/stats/overview/'),
  storage: () => api.get('/admin/stats/storage/'),
  users: () => api.get('/admin/stats/users/'),
  filetypes: () => api.get('/admin/stats/filetypes/'),
  topDownloads: (limit = 20) => api.get(`/admin/stats/top-downloads/?limit=${limit}`),
};
